// TQ #890/#960: cockpit-api meldet einen ERPNext-Status 401/403 als HTTP 403. Dem Kunden zeigen wir
// nie den Rohtext des Backends (er nennt interne Systeme), sondern immer den deutschen Standardtext.
// Status != 403 (502, Netzfehler, ...): null, die jeweilige Stelle behaelt ihren eigenen Text.
export const GENERIC_FORBIDDEN_TEXT = 'Dafür fehlt Ihnen die Berechtigung.'

export function forbiddenText(err: unknown): string | null {
  const res = (err as { response?: { status?: number } } | null)?.response
  return res && res.status === 403 ? GENERIC_FORBIDDEN_TEXT : null
}
